/**
 * Formats a timestamp (milliseconds since epoch) to a human readable date string
 * @param timestamp - Timestamp in milliseconds since epoch
 * @returns Formatted date string (e.g. "31 March 2024 at 2:05 PM")
 */
export const formatTimestamp = (
	timestamp: string | number | undefined,
): string => {
	if (!timestamp) return '-';

	return new Date(Number(timestamp))
		.toLocaleString('en-GB', {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
			hour12: true,
		})
		.replace(' at', ',');
};

export const formatDateISO = (
	timestamp: string | number | undefined,
): string | undefined => {
	if (!timestamp) return undefined;
	const date = new Date(
		typeof timestamp === 'string' ? parseInt(timestamp) : timestamp,
	);
	return isNaN(date.getTime()) ? undefined : date.toISOString().split('T')[0];
};

export function parseDateValue(
	rawValue: string | number | Date | null | undefined,
): Date | null {
	if (!rawValue) return null;
	if (rawValue instanceof Date)
		return isNaN(rawValue.getTime()) ? null : rawValue;
	if (typeof rawValue === 'number')
		return isNaN(rawValue) ? null : new Date(rawValue);
	if (typeof rawValue === 'string') {
		const parsed = parseInt(rawValue);
		return isNaN(parsed) ? null : new Date(parsed);
	}
	return null;
}

export default {
	formatTimestamp,
};
